import api from 'api'
import { defaultHandleError } from 'util/downloadFile'
import { previewFile } from 'util/previewFile'

import { ImpressaoMedicamentosInput, ReimpressaoReceitaMedicamentosDto } from './ImpressaoMedicamentosInput'

export const downloadMedicamentos = async (input: ImpressaoMedicamentosInput) => {
  return await api.prescricaoMedicamento
    .imprimirMedicamentos(input)
    .then((response) => {
      previewFile(new Blob([response.data], { type: 'application/pdf' }), 'Imprimir prescrição de medicamentos')
      return response
    })
    .catch(defaultHandleError)
}

export const downloadReimpressaoMedicamentos = async (input: ReimpressaoReceitaMedicamentosDto) => {
  return await api.prescricaoMedicamento
    .reimprimirMedicamentos(input)
    .then((response) => {
      previewFile(new Blob([response.data], { type: 'application/pdf' }), 'Reimprimir prescrição de medicamentos')
      return response
    })
    .catch(defaultHandleError)
}
